module.exports = __webpack_public_path__ + "static/8-f03d4c590f1ab98e1933d42120c6ca2f.jpg";